import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const SpecificationsTable = ({ specifications }) => {
  if (!specifications) return null;

  try {
    // Parse the specifications JSON string
    const specs = JSON.parse(specifications);
    
    // Check if it's the new format (array of objects with product1, product2, etc.)
    if (Array.isArray(specs) && specs.length > 0 && specs[0].product1) {
      // New format - multiple specification tables
      return (
        <div className="specifications-container">
          {specs.map((productSpec, tableIndex) => {
            const productKey = Object.keys(productSpec)[0]; // product1, product2, etc.
            const tableSpecs = productSpec[productKey];
            
            return (
              <div key={tableIndex} className="mb-4">
                {/* Table Header */}
                {/* <div className="specification-table-header">
                  <h5 className="mb-0">
                    📋 Specification Set {tableIndex + 1}
                  </h5>
                </div> */}
                
                {/* Table Content */}
                <table className="table table-bordered mb-0">
                  <tbody>
                    {/* Size Specifications */}
                    {tableSpecs.size && (
                      <tr>
                        <th scope="row" className="spec-label">Size</th>
                        <td className="spec-value">
                          {formatSizeSpec(tableSpecs.size)}
                        </td>
                      </tr>
                    )}
                    
                    {/* Thickness Specifications */}
                    {tableSpecs.thickness && (
                      <tr>
                        <th scope="row" className="spec-label">Thickness</th>
                        <td className="spec-value">
                          {formatThicknessSpec(tableSpecs.thickness)}
                        </td>
                      </tr>
                    )}
                    
                    {/* Underpad Specifications */}
                    {tableSpecs.underpad && (
                      <tr>
                        <th scope="row" className="spec-label">Underpad</th>
                        <td className="spec-value">
                          {formatUnderpadSpec(tableSpecs.underpad)}
                        </td>
                      </tr>
                    )}
                    
                    {/* Wear Resistant Specifications */}
                    {(tableSpecs['wear-resistant'] || tableSpecs.wearResistant) && (
                      <tr>
                        <th scope="row" className="spec-label">Wear Resistant</th>
                        <td className="spec-value">
                          {formatWearResistantSpec(tableSpecs['wear-resistant'] || tableSpecs.wearResistant)}
                        </td>
                      </tr>
                    )}
                     {/* {tableSpecs.price && (
                      <tr>
                        <th scope="row" className="spec-label">Price</th>
                        <td className="spec-value">
                          {formatPrice(tableSpecs.price)}
                        </td>
                      </tr>
                    )}
                     {tableSpecs.inventory && (
                      <tr>
                        <th scope="row" className="spec-label">Inventory</th>
                        <td className="spec-value">
                          {formatInventory(tableSpecs.inventory)}
                        </td>
                      </tr>
                    )} */}
                  </tbody>
                </table>
              </div>
            );
          })}
          
          {/* Add some custom CSS for better styling */}
          <style jsx>{`
            .specifications-container {
              margin-top: 20px;
            }
            
            .specification-table-wrapper {
              border: 2px solid #e3f2fd;
              border-radius: 8px;
              overflow: hidden;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            
            .specification-table-header {
              {/* background: linear-gradient(135deg, #1976d2, #1565c0); */}
              color: white;
              padding: 12px 16px;
              font-weight: 600;
            }
            
            .spec-label {
              background-color: #f8f9fa;
              font-weight: 600;
              color: #333;
              width: 35%;
              vertical-align: middle;
            }
            
            .spec-value {
              background-color: #ffffff;
              font-weight: 500;
              vertical-align: middle;
            }
            
            .table-bordered td, .table-bordered th {
              border: 1px solid #dee2e6;
            }
          `}</style>
        </div>
      );
    } else {
      // Old format fallback - group specifications by type
      const groupedSpecs = specs.reduce((acc, spec) => {
        if (!acc[spec.type]) acc[spec.type] = [];
        acc[spec.type].push(spec.data);
        return acc;
      }, {});

      // Define the specification types you want to display and their labels
      const specTypes = [
        { key: 'size', label: 'Size' },
        { key: 'thickness', label: 'Thickness' },
        { key: 'underpad', label: 'Underpad Option' },
        { key: 'wear-resistant', label: 'Wear Resistant Layer' }
      ];

      return (
        <div className="specification-table-wrapper">
          <div className="specification-table-header">
           
          </div>
          <table className="table table-bordered mb-0">
            <tbody>
              {specTypes.map(({ key, label }) => (
                groupedSpecs[key] && (
                  <tr key={key}>
                    <th scope="row" className="spec-label">{label}</th>
                    <td className="spec-value">{formatSpecValueOld(key, groupedSpecs[key])}</td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  } catch (error) {
    console.error("Error parsing specifications:", error);
    return (
      <div className="alert alert-warning">
        <small>Unable to display specifications</small>
      </div>
    );
  }

  // Helper functions for formatting new format specifications
  function formatSizeSpec(sizeData) {
    const parts = [];
    if (sizeData.length1 && sizeData.width1) {
      parts.push(`${sizeData.length1}' x ${sizeData.width1}'`);
    }
    if (sizeData.length2 && sizeData.width2) {
      parts.push(`${sizeData.length2}' x ${sizeData.width2}'`);
    }
    return parts.join(' and ') || 'N/A';
  }

  function formatThicknessSpec(thicknessData) {
    const parts = [];
    if (thicknessData.option1) {
      parts.push(`${thicknessData.option1}mm`);
    }
    if (thicknessData.option2) {
      parts.push(`${thicknessData.option2}mm`);
    }
    return parts.join(', ') || 'N/A';
  }

  function formatUnderpadSpec(underpadData) {
    return underpadData.thickness ? `${underpadData.thickness}mm` : 'N/A';
  }
    function formatPrice(Pricedata) {
    return Pricedata.Price ? `${Pricedata.Price}` : 'N/A';
  }
    function formatInventory(InventoryData) {
    return InventoryData.Inventory ? `${InventoryData.Inventory}` : 'N/A';
  }

  function formatWearResistantSpec(wearData) {
    const parts = [];
    if (wearData.layer1) {
      parts.push(`${wearData.layer1}mil`);
    }
    if (wearData.layer2) {
      parts.push(`${wearData.layer2}mil`);
    }
    return parts.join(', ') || 'N/A';
  }

  // Helper function for old format (fallback)
  function formatSpecValueOld(type, dataArray) {
    switch (type) {
      case 'size':
        return dataArray.map(data => 
          `${data.length1 || ''}${data.width1 ? ` x ${data.width1}"` : ''}${data.length2 || data.width2 ? ` and ${data.length2 || ''} x ${data.width2 || ''}` : ''}`
        ).join(', ');
      
      case 'thickness':
        return dataArray.map(data => 
          `${data.option1 || data.thickness || ''}mm${data.option2 ? `, ${data.option2}mm` : ''}`
        ).join(', ');
      
      case 'underpad':
        return dataArray.map(data => 
          `${data.thickness || ''}mm`
        ).join(', ');
      
      case 'wear-resistant':
        return dataArray.map(data => 
          `${data.layer1 || ''}mil${data.layer2 ? `, ${data.layer2}mil` : ''}`
        ).join(', ');
      
      default:
        return JSON.stringify(dataArray);
    }
  }
};



const ProductDetails = () => {
  const { productId } = useParams(); // Get product ID from URL
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true); // Add a loading state
  const [mainImage, setMainImage] = useState(""); // State for main image
  const [quantity, setQuantity] = useState(1);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userId = Cookies.get("userId");
  const handlePlaceOrder = async () => {
    const userId = Cookies.get("userId");
    if (!userId) {
      toast.error("User not authenticated");
      window.location.href = "/log-in";
      return;
    }

    try {
      // Show loading state (optional)
      toast.info("Placing order...");

      const data = new FormData();
      data.append("user_id", userId);
      data.append("product_id", productId); // Adjust based on your product object structure
      data.append("quantity", quantity);


      const endpoint = "https://leapatinternational.com/admin/api/v1/web_buy_now.php";

      const response = await fetch(endpoint, {
        method: "POST",
        body: data, // Send as FormData
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("Order placed successfully!");
        window.location.href = "/order-complate"; // or wherever you want to redirect

      } else {
        toast.error(result.message || "Failed to place order");
        console.error("Order failed:", result);
      }

    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("An error occurred while placing the order");
    }
  };
  const handleAddToCart = async () => {

    setIsLoading(true);

    try {
      // Make sure this matches your cookie name
      if (!userId) {
        toast.error(
          "Please log in to add items to cart"
        );
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("product_id", productId);
      formData.append("quantity", quantity);

      // Make API call
      const response = await fetch("https://leapatinternational.com/admin/api/v1/web_addtocart.php", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      // Handle successful response
      if (result.success || result.status === "success") {
        toast.success("Product Added  successfully!");

      } else {
        throw new Error(result.message || "Failed to add product to cart");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(

        "Failed to add product to cart");
    } finally {
      setIsLoading(false);
    }
  };
  // useEffect(() => {
  //   fetch(`https://leapatinternational.com/admin/api/v1/web_get_products_details_by_id=${productId}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setProduct(data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching product details:", error);
  //       setLoading(false);
  //     });
  // }, [productId]);
  useEffect(() => {
    const formData = new FormData();
    formData.append('product_id', productId); // Append productId as form data

    fetch(`https://leapatinternational.com/admin/api/v1/web_get_products_details_by_id.php`, {
      method: 'POST',
      body: formData, // Send as FormData (multipart/form-data)
      // Headers are not manually set for FormData; browser sets them automatically
    })
      .then((response) => response.json())
      .then((data) => {
        setProduct(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
        setLoading(false);
      });
  }, [productId]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading message
  }

  if (!product) {
    return <div>No product found.</div>; // Handle no data case
  }
  return (
    <div>
      {/* Spinner Start */}

      {/* Spinner End */}



      <div class="container">

        <div className="product-container">
          {/* Left Section - Images */}
          <div className="product-images">
            <div className="thumbnail-images">
              {product?.images?.map((img, index) => {
                const imageUrl = `https://admin.leapatinternational.com/assets/images/product/${img}`;
                return (
                  <img
                    key={index}
                    src={imageUrl}
                    alt={`Thumbnail ${index + 1}`}
                    onClick={() => setMainImage(imageUrl)} // Change main image on click
                    className="thumbnail"
                    style={{ cursor: "pointer", border: mainImage === imageUrl ? "2px solid #000" : "none" }}
                  />
                );
              })}
            </div>
            <div className="main-image">
              <img src={mainImage || `${product.main_image}`} alt={product.title} />
            </div>
          </div>

          {/* Right Section - Details */}
          <div className="product-details">
            <h1 className="product-title">{product.product_name}</h1>
            <p className="product-description" dangerouslySetInnerHTML={{ __html: product.description }}></p>
            <h2>Specification</h2>
            {/* <table class="table"><thead></thead>                        <tbody>
              <tr> <th scope="row">Size</th> <td>7' x 48' and 9' x 48"</td> </tr> <tr> <th scope="row">Thickness</th> <td>4mm, 5mm</td> </tr> <tr> <th scope="row">Underpad Option</th> <td>1mm, 1.5mm</td> </tr> <tr> <th scope="row">Wear Resistant layer</th> <td>12mil, 20mil</td></tr></tbody></table> */}
              <SpecificationsTable specifications={product.specifications} />

            {/* Quantity Controls and Order Button - Bootstrap Version */}
            {/* {userId ? (
              <div className="d-flex flex-row align-items-center gap-0 mt-4">
                <div className=" d-flex flex-row gap-2" style={{ width: '250px' }}>
                  <button
                    className="btn btn-outline-dark shadow-none border-2"
                    type="button"
                    onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                  >
                    <i className="bi bi-dash"></i>
                  </button>

                  <input
                    type="number"
                    className="form-control text-center  border-2 border-dark rounded-3 text-black shadow-none font-weight-bold"
                    min="1"
                    style={{ width: '40%' }}
                    value={quantity}
                    onChange={(e) =>
                      setQuantity(Math.max(1, parseInt(e.target.value)))
                    }

                  />
                  <button
                    className="btn btn-outline-dark border-2 shadow-none font-weight-bold"
                    type="button"
                    onClick={() => setQuantity(prev => prev + 1)}
                  >
                    <i className="bi bi-plus font-weight-bold"></i>
                  </button>
                </div>
                <button className="btn-signin w-auto rounded-3 pt-2 pb-2" onClick={handleAddToCart}>
                  Add To Cart
                </button>
                <button className="btn-signin w-auto rounded-3 pt-2 pb-2 ms-2" onClick={handlePlaceOrder}>
                  Buy now
                </button>
              </div>
            ) : null} */}
          </div>
          {/* Features Section */}
          <div className="features-section">
            <h2>Features</h2>
            <div className="features-grid">
              <div className="feature-item">
                <img src="/assets/img/dur.png" alt="Highly Durable" />
                <p>Highly Durable</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/water.png" alt="Waterproof" />
                <p>Waterproof</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/stain.png" alt="Stain-Resistant" />
                <p>Stain-Resistant</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/scratch.png" alt="Soundproof" />
                <p>Scratch-Resistant</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/impact.png" alt="Soundproof" />
                <p>Impact-Resistant</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/sound.png" alt="Soundproof" />
                <p>Soundproof</p>
              </div>

              <div className="feature-item">
                <img src="/assets/img/easy.png" alt="Highly Durable" />
                <p>Easy to Clean</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/hyg.png" alt="Waterproof" />
                <p>Hygienic Surface</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/env.png" alt="Stain-Resistant" />
                <p>Environmentally Friendly</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/auth.png" alt="Soundproof" />
                <p>Authentic Appearance</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/eq.png" alt="Soundproof" />
                <p>Easy & Quick Installation</p>
              </div>
              <div className="feature-item">
                <img src="/assets/img/low.png" alt="Soundproof" />
                <p>Low Maintenance</p>
              </div>


            </div>
          </div>
        </div>
      </div>


      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
        <i className="bi bi-arrow-up"></i>
      </a>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        limit={1}

      />
      {/* Optional: Add any other content or components here */}

      <style>
        {`
                    /* Add your custom CSS here */
                    .service-item-top {
                      transition: transform 0.3s ease-in-out;
                    }
                    .service-item-top:hover {
                      transform: scale(1.05);
                    }
                .product-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top:135px;
}

.product-images {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.thumbnail-images img {
  width: 60px;
  height: 80px;
  margin-right: 8px;
  cursor: pointer;
  border: 2px solid #ddd;
}

.main-image img {
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
}

.product-details {
  width: 55%;
  padding: 20px;
}

.series {
  font-size: 14px;
  color: #777;
  text-transform: uppercase;
}

.product-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product-description {
  font-size: 16px;
  color: #555;
  line-height: 1.5;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.spec-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.view-btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}

.features-section {
  width: 100%;
  margin-top: 40px;
}

.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
 flex: 0 0 16.666667%;
  max-width: 16.666667%;
  -webkit-box-flex: 0;
  text-align: center;
}

.feature-item img {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}

                    /* Add any additional styling you want */
                    @media (max-width: 768px) {
                    .product-images {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
  .product-details {
    width: 100%;
    }
        }
                  `}
      </style>
    </div>
  );
};

export default ProductDetails;
